var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.23 18.002C18.39 17.912 17.65 18.3218 17.27 18.9915H7.73C7.51 18.6217 7.18 18.3218 6.79 18.1619L6.54 15.993H19.4C19.63 15.993 19.84 15.8331 19.89 15.6032L21.99 5.6082C22.06 5.29835 21.82 4.9985 21.5 4.9985H5.24L4.94 2.43978C4.91 2.18991 4.7 2 4.44 2H2.5C2.22 2 2 2.21989 2 2.49975V3.49925C2 3.77911 2.22 3.999 2.5 3.999H3.11L4.8 18.3918C4.17 18.8816 3.81 19.7411 4.11 20.6407C4.32 21.3003 4.89 21.8101 5.57 21.95C6.49 22.1399 7.32 21.7101 7.74 21.0005H17.28C17.63 21.6002 18.27 22 19.01 22C20.2 22 21.16 20.9405 20.99 19.7111C20.86 18.8316 20.13 18.1119 19.24 18.012L19.23 18.002ZM19.75 6.9975L18.2 13.994H6.3L5.48 6.9975H19.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCommerce);
export default __webpack_public_path__ + "static/media/MenuCommerce.efd41b5986c3f384cd65cf6c0b253c03.svg";
export { ForwardRef as ReactComponent };